import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../../../contentful/graphql/pricing-page";

import { RELAY_API_CONTENTFUL } from "@/utils/constant";
import { init as initRelay } from "../../../init-relay-streaming";
import { NonProfitPricingPage } from "../../../pages/teams/nonprofit/pricing/non-profit-pricing-page";

initRelay(
    NonProfitPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("nonprofit", window.location),
    RELAY_API_CONTENTFUL
);
